import { makeStyles } from '@mui/styles';
import { Mode } from '../../constants/enums';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    homePage: {
      display: 'flex',
      height: '100%',
      padding: '10px',
      boxSizing: 'border-box',
      width: '100%',
      flexDirection: 'column',
      background: theme.palette.mode === 'dark' ? '' : '#f9fafc',
    },
    homePageTiles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      gap: '10px',
      padding: '10px',
      boxSizing: 'border-box',
      width: '100%',
      flexDirection: 'row',
    },
    twoInRow: {
      display: 'flex',
      flex: '1 1',
      justifyContent: 'space-around',
      gap: '10px',
      flexDirection: 'row',
      padding: '10px',
      overflow: 'hidden',
    },
    homePageTile: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      background: theme.palette.mode === Mode.Dark ? theme.palette.background.default : 'white',
      color: theme.palette.text.primary,
      borderRadius: '15px',
      justifyContent: 'space-between',
      gap: '20px',
      '& h1': { fontWeight: 500, fontSize: '20px' },
      '& p': {
        fontSize: '15px',
        lineHeight: '20px',
        color: 'rgba(129, 129, 129, 0.72)',
        textWrap: 'normal',
      },
      border: '1px solid #dfe5ee',
      borderColor: theme.palette.mode === Mode.Dark ? '#FFFFFF1F' : undefined,
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },
    container: {
      width: '100%',
      display: 'flex',
    },
    ticketsContainer: {
      overflow: 'hidden',
      borderRadius: '15px',
      width: '100%',
      padding: '10px',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      background: theme.palette.mode === 'dark' ? theme.palette.background.default : 'white',
      border: '1px solid #dfe5ee',
      borderColor: theme.palette.mode === Mode.Dark ? '#FFFFFF1F' : undefined,
    },
    tickets: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '15px',
      overflowY: 'auto',
    },
    ticketTitle: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      gap: '5px',
    },
    ticketMessageDate: {
      marginLeft: 'auto',
      fontSize: 'small',
    },
    ticketId: {
      color: theme.palette.mode === 'dark' ? 'lightgrey' : '#6a6a6a',
    },
    chatMessage: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '5px',
      width: '100%',
      overflow: 'hidden',
    },
    name: {
      fontWeight: 'bold',
      flexShrink: '0',
      whiteSpace: 'nowrap',
    },
    message: {
      flex: '1 1 auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      minWidth: '0',
    },
    unreadCount: {
      borderRadius: '50%',
      backgroundColor: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.main,
      color:
        theme.palette.mode === 'dark'
          ? theme.palette.background.default
          : theme.palette.secondary.contrastText,
      padding: '6px',
      fontSize: 'small',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    ticket: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      padding: '5px 10px',
      border: '1px solid transparent',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out',
      borderRadius: '5px',
      '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.15)',
      },
      borderBottom: '1px solid #dfe5ee',
    },
    ticketStatus: {
      padding: '4px 12px',
      borderRadius: '12px',
      color: theme.palette.common.white,
      fontSize: 'small',
      display: 'inline-block',
      fontWeight: 500,
      width: 'fit-content',
    },
    title: {
      borderBottom: '1px solid #ddd',
      padding: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    recentMessagesRangeControl: {
      flex: '0 0 auto',
    },
    recentMessagesRangeSelect: {
      '&.MuiInputBase-root': {
        minWidth: '120px',
      },
      '& .MuiSelect-select': {
        paddingTop: '6px',
        paddingBottom: '6px',
      },
    },
    recentMessagesEmptyState: {
      color: theme.palette.text.secondary,
      padding: '10px 0',
    },
    seeAll: {
      cursor: 'pointer',
      fontSize: 'small',
      padding: '5px 10px',
      borderRadius: '5px',
      background: theme.palette.mode !== 'dark' ? theme.palette.primary.main : 'black',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        width: '10px',
        height: '10px',
        transform: 'rotate(90deg)',
        '& path': {
          fill: 'white',
        },
      },
    },
    messageDate: {
      opacity: '0.5',
    },
    chatsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      padding: '10px 0',
      overflow: 'auto',
    },
    chatItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      padding: '8px 10px',
      cursor: 'pointer',
      borderRadius: '8px',
      transition: 'background-color 0.2s ease-in-out',
      '&:hover': {
        backgroundColor:
          theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
      },
    },
    chatAvatar: {
      width: '40px',
      height: '40px',
      flexShrink: 0,
    },
    chatContent: {
      flex: '1 1 auto',
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    chatHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
      position: 'relative',
    },
    messageWrapper: {
      display: 'flex',
      gap: '4px',
      alignItems: 'center',
    },
    chatSenderName: {
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    chatTime: {
      marginLeft: 'auto',
      fontSize: '12px',
      color: theme.palette.text.secondary,
      whiteSpace: 'nowrap',
    },
    chatMessagePreview: {
      color: theme.palette.text.secondary,
      lineHeight: '1.4',
    },
    lastMessageLabel: {
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
    titleWrapper: {
      maxWidth: '65%',
    },
    button: {
      '&.MuiButtonBase-root': {
        padding: '20px',
        borderRadius: '12px',
        fontSize: '18px',

        '& .MuiButton-startIcon': {
          position: 'absolute',
          left: '20px',
          background: '#eff2fb',
          borderRadius: '50%',
          height: '44px',
          width: '44px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 0,
        },
        '& .MuiButton-endIcon': {
          position: 'absolute',
          right: '20px',
        },
        '& svg': {
          stroke: theme.palette.mode === Mode.Dark ? '#000' : undefined,
          '& path': {
            fill: theme.palette.mode === Mode.Dark ? '#fff' : undefined,
          }
        },
      },
    },
    chatChip: {
      '&.MuiChip-root': {
        '& .MuiChip-label': {
          padding: '0',
        },
        borderRadius: '6px',
        height: '18px',
        fontSize: '12px',
        lineHeight: '18px',
        padding: '1px 8px',
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.main,
        color: theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.secondary.contrastText,
      },
    },
    searchFieldClassName: {
      minWidth: '100%',
    }
  };
});

export default useStyles;
